module.exports = __webpack_public_path__ + "static/media/identity-mapping-add.5e716074.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/identity-mapping-add.md
// module id = 1098
// module chunks = 0